// import * as React from "react";
// import { Provider, Flex, Text, Header } from "@fluentui/react-northstar";
import { useEffect } from "react";
// import { useTeams } from "msteams-react-base-component";
import * as microsoftTeams from "@microsoft/teams-js";
import { useData, useTeamsUserCredential } from "@microsoft/teamsfx-react";
// import { TeamsFxContext } from "../Context";
import { Button, FluentProvider, teamsDarkTheme, teamsHighContrastTheme, teamsLightTheme, Title1, Title2, tokens } from "@fluentui/react-components";
import config from "../lib/config";
import { TeamsFxContext } from "../Context";
// import config from "../lib/config";
 
/**
 * Implementation of FeedbackApp remove page
 */
export const FeedbackAppTabRemove = () => {
   
    const appInfo = useData(async ()=>
        {
            microsoftTeams.app.initialize();
            return microsoftTeams.app.getContext();
        }).data;

    const { theme, themeString, teamsUserCredential } = useTeamsUserCredential({
        initiateLoginEndpoint: config.initiateLoginEndpoint!,
        clientId: config.clientId!,
        });
       
    useEffect(() => {
        if (appInfo != undefined) {
            microsoftTeams.app.initialize().then(()=>{
                microsoftTeams.pages.config.registerOnRemoveHandler((removeEvent) => {
                    // Here you can designate the tab content to be removed and/or archived.
                        const configPromise = microsoftTeams.pages.getConfig();
                        configPromise.
                            then((configuration) => {
                                configuration.contentUrl = "...";
                                removeEvent.notifySuccess()}).
                            catch((error) => {removeEvent.notifyFailure("failure message" + error)});
                    });
            })
            
        }
    }, [appInfo]);
 
    function onClick()  {
        microsoftTeams.pages.config.setValidityState(true);
    }
 
    return (
       <TeamsFxContext.Provider value={{ theme, themeString, teamsUserCredential }}>
                     <FluentProvider
                       theme={
                         themeString === "dark"
                           ? teamsDarkTheme
                           : themeString === "contrast"
                           ? teamsHighContrastTheme
                           : {
                               ...teamsLightTheme,
                               colorNeutralBackground1: "#f5f5f5",
                             }
                       }
                       style={{ background: tokens.colorNeutralBackground3 }}
                     >
            <div className="removeTab">
                <Title2 style={{fontSize: '14px', display: 'grid', alignItems: 'center', textAlign: 'center'}}>You're about to remove your tab...</Title2>
                <p>You can just add stuff here if you want to clean up when removing the tab. For instance, if you have stored data in an external repository, you can delete or archive it here. If you don't need this remove page you can remove it.</p>
                <Button className={(themeString == 'contrast'?'button-contrast' : 'button-light')}  style={{padding: "10px", borderRadius: "4px", margin: "0 0.5rem", height: "50px", fontSize: "12px" } } onClick={onClick}>Delete this tab and all underlying data?</Button>
            </div>
            </FluentProvider>
        </TeamsFxContext.Provider>
    );
};
 
 